import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=50cfc5ca&scoped=true&"
import script from "./ContactBlock.vue?vue&type=script&lang=ts&"
export * from "./ContactBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ContactBlock.vue?vue&type=style&index=1&id=50cfc5ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfc5ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VListItem,VListItemContent,VListItemGroup,VMenu,VProgressCircular,VRow,VTextField})
